import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Typography, Link } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
    textAlign: "center"
  },
  ltr: {
    direction: "ltr"
  }
}));

const Footer = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography className={classes.ltr} variant="body1">
        <Link
          component="a"
          href="https://www.farabazaar.ir/"
          target="_blank"
        >
          &copy;{new Date().getFullYear()} All Rights Reserved
        </Link>
      </Typography>
      <Typography className={classes.ltr} variant="caption">
        Created with love for the environment
      </Typography>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string
};

export default Footer;
